export const customKeyboardBR = [
  { character: '1', variation: '' },
  { character: '2', variation: '' },
  { character: '3', variation: '' },
  { character: '4', variation: '' },
  { character: '5', variation: '' },
  { character: '6', variation: '' },
  { character: '7', variation: '' },
  { character: '8', variation: '' },
  { character: '9', variation: '' },
  { character: '0', variation: '' },
  { character: 'q', variation: '' },
  { character: 'w', variation: '' },
  { character: 'e', variation: '' },
  { character: 'r', variation: '' },
  { character: 't', variation: '' },
  { character: 'y', variation: '' },
  { character: 'u', variation: '' },
  { character: 'i', variation: '' },
  { character: 'o', variation: '' },
  { character: 'p', variation: '' },
  { character: 'a', variation: '' },
  { character: 's', variation: '' },
  { character: 'd', variation: '' },
  { character: 'f', variation: '' },
  { character: 'g', variation: '' },
  { character: 'h', variation: '' },
  { character: 'j', variation: '' },
  { character: 'k', variation: '' },
  { character: 'l', variation: '' },
  { character: '@', variation: '' },
  { character: 'z', variation: '' },
  { character: 'x', variation: '' },
  { character: 'c', variation: '' },
  { character: 'v', variation: '' },
  { character: 'b', variation: '' },
  { character: 'n', variation: '' },
  { character: 'm', variation: '' },
  { character: '.', variation: '' },
  { character: ',', variation: '' },
  { character: '-', variation: '' },
];

export const uppercaseKeyboardBR = [
  { character: '1', variation: '' },
  { character: '2', variation: '' },
  { character: '3', variation: '' },
  { character: '4', variation: '' },
  { character: '5', variation: '' },
  { character: '6', variation: '' },
  { character: '7', variation: '' },
  { character: '8', variation: '' },
  { character: '9', variation: '' },
  { character: '0', variation: '' },
  { character: 'Q', variation: '' },
  { character: 'W', variation: '' },
  { character: 'E', variation: '' },
  { character: 'R', variation: '' },
  { character: 'T', variation: '' },
  { character: 'Y', variation: '' },
  { character: 'U', variation: '' },
  { character: 'I', variation: '' },
  { character: 'O', variation: '' },
  { character: 'P', variation: '' },
  { character: 'A', variation: '' },
  { character: 'S', variation: '' },
  { character: 'D', variation: '' },
  { character: 'F', variation: '' },
  { character: 'G', variation: '' },
  { character: 'H', variation: '' },
  { character: 'J', variation: '' },
  { character: 'K', variation: '' },
  { character: 'L', variation: '' },
  { character: '@', variation: '' },
  { character: 'Z', variation: '' },
  { character: 'X', variation: '' },
  { character: 'C', variation: '' },
  { character: 'V', variation: '' },
  { character: 'B', variation: '' },
  { character: 'N', variation: '' },
  { character: 'M', variation: '' },
  { character: '.', variation: '' },
  { character: ',', variation: '' },
  { character: '-', variation: '' },
];

export const variationKeyboardBR = [
  { character: 'á', variation: '' },
  { character: 'à', variation: '' },
  { character: 'ä', variation: '' },
  { character: 'â', variation: '' },
  { character: 'ã', variation: '' },
  { character: 'å', variation: '' },
  { character: 'ą', variation: '' },
  { character: 'æ', variation: '' },
  { character: 'ā', variation: '' },
  { character: 'ç', variation: '' },
  { character: 'ć', variation: '' },
  { character: 'č', variation: '' },
  { character: 'é', variation: '' },
  { character: 'è', variation: '' },
  { character: 'ë', variation: '' },
  { character: 'ê', variation: '' },
  { character: 'ę', variation: '' },
  { character: 'ė', variation: '' },
  { character: 'ē', variation: '' },
  { character: 'ğ', variation: '' },
  { character: 'í', variation: '' },
  { character: 'ï', variation: '' },
  { character: 'ì', variation: '' },
  { character: 'î', variation: '' },
  { character: 'į', variation: '' },
  { character: 'ī', variation: '' },
  { character: 'ñ', variation: '' },
  { character: 'ń', variation: '' },
  { character: 'ó', variation: '' },
  { character: 'ò', variation: '' },
  { character: 'ö', variation: '' },
  { character: 'ô', variation: '' },
  { character: 'õ', variation: '' },
  { character: 'ø', variation: '' },
  { character: 'œ', variation: '' },
  { character: 'ō', variation: '' },
  { character: 'š', variation: '' },
  { character: 'ṡ', variation: '' },
  { character: 'ş', variation: '' },
  { character: 'β', variation: '' },
  { character: 'ú', variation: '' },
  { character: 'ü', variation: '' },
  { character: 'ù', variation: '' },
  { character: 'û', variation: '' },
  { character: 'ū', variation: '' },
  { character: 'ý', variation: '' },
  { character: 'ÿ', variation: '' },
  { character: 'ź', variation: '' },
  { character: 'ż', variation: '' },
  { character: 'ž', variation: '' },
];

export const uppercaseVariationKeyboardBR = [
  { character: 'Á', variation: '' },
  { character: 'À', variation: '' },
  { character: 'Ä', variation: '' },
  { character: 'Â', variation: '' },
  { character: 'Ã', variation: '' },
  { character: 'Å', variation: '' },
  { character: 'Ą', variation: '' },
  { character: 'Æ', variation: '' },
  { character: 'Ā', variation: '' },
  { character: 'Ç', variation: '' },
  { character: 'Ć', variation: '' },
  { character: 'Č', variation: '' },
  { character: 'É', variation: '' },
  { character: 'È', variation: '' },
  { character: 'Ë', variation: '' },
  { character: 'Ê', variation: '' },
  { character: 'Ę', variation: '' },
  { character: 'Ė', variation: '' },
  { character: 'Ē', variation: '' },
  { character: 'Ğ', variation: '' },
  { character: 'Í', variation: '' },
  { character: 'Ï', variation: '' },
  { character: 'Ì', variation: '' },
  { character: 'Î', variation: '' },
  { character: 'Į', variation: '' },
  { character: 'Ī', variation: '' },
  { character: 'Ñ', variation: '' },
  { character: 'Ń', variation: '' },
  { character: 'Ó', variation: '' },
  { character: 'Ò', variation: '' },
  { character: 'Ö', variation: '' },
  { character: 'Ô', variation: '' },
  { character: 'Õ', variation: '' },
  { character: 'Ø', variation: '' },
  { character: 'Œ', variation: '' },
  { character: 'Ō', variation: '' },
  { character: 'Š', variation: '' },
  { character: 'Ṡ', variation: '' },
  { character: 'Ş', variation: '' },
  { character: 'Β', variation: '' },
  { character: 'Ú', variation: '' },
  { character: 'Ü', variation: '' },
  { character: 'Ù', variation: '' },
  { character: 'Û', variation: '' },
  { character: 'Ū', variation: '' },
  { character: 'Ý', variation: '' },
  { character: 'Ÿ', variation: '' },
  { character: 'Ź', variation: '' },
  { character: 'Ż', variation: '' },
  { character: 'Ž', variation: '' },
];

export const symbolsKeyboardBR = [
  { character: '[', variation: '' },
  { character: ']', variation: '' },
  { character: '{', variation: '' },
  { character: '}', variation: '' },
  { character: '#', variation: '' },
  { character: '%', variation: '' },
  { character: '^', variation: '' },
  { character: '*', variation: '' },
  { character: '+', variation: '' },
  { character: '=', variation: '' },
  { character: '_', variation: '' },
  { character: '-', variation: '' },
  { character: '/', variation: '' },
  { character: '|', variation: '' },
  { character: '~', variation: '' },
  { character: '<', variation: '' },
  { character: '>', variation: '' },
  { character: '&', variation: '' },
  { character: '$', variation: '' },
  { character: '€', variation: '' },
  { character: '£', variation: '' },
  { character: '¥', variation: '' },
  { character: '.', variation: '' },
  { character: ',', variation: '' },
  { character: ':', variation: '' },
  { character: ';', variation: '' },
  { character: '¿', variation: '' },
  { character: '?', variation: '' },
  { character: '¡', variation: '' },
  { character: '!', variation: '' },
];

export const customKeyboardES = [
  { character: '1', variation: '' },
  { character: '2', variation: '' },
  { character: '3', variation: '' },
  { character: '4', variation: '' },
  { character: '5', variation: '' },
  { character: '6', variation: '' },
  { character: '7', variation: '' },
  { character: '8', variation: '' },
  { character: '9', variation: '' },
  { character: '0', variation: '' },
  { character: 'q', variation: '' },
  { character: 'w', variation: '' },
  { character: 'e', variation: '' },
  { character: 'r', variation: '' },
  { character: 't', variation: '' },
  { character: 'y', variation: '' },
  { character: 'u', variation: '' },
  { character: 'i', variation: '' },
  { character: 'o', variation: '' },
  { character: 'p', variation: '' },
  { character: 'a', variation: '' },
  { character: 's', variation: '' },
  { character: 'd', variation: '' },
  { character: 'f', variation: '' },
  { character: 'g', variation: '' },
  { character: 'h', variation: '' },
  { character: 'j', variation: '' },
  { character: 'k', variation: '' },
  { character: 'l', variation: '' },
  { character: 'ñ', variation: '' },
  { character: 'z', variation: '' },
  { character: 'x', variation: '' },
  { character: 'c', variation: '' },
  { character: 'v', variation: '' },
  { character: 'b', variation: '' },
  { character: 'n', variation: '' },
  { character: 'm', variation: '' },
  { character: '.', variation: '' },
  { character: '-', variation: '' },
  { character: '@', variation: '' },
];

export const uppercaseKeyboardES = [
  { character: '1', variation: '' },
  { character: '2', variation: '' },
  { character: '3', variation: '' },
  { character: '4', variation: '' },
  { character: '5', variation: '' },
  { character: '6', variation: '' },
  { character: '7', variation: '' },
  { character: '8', variation: '' },
  { character: '9', variation: '' },
  { character: '0', variation: '' },
  { character: 'Q', variation: '' },
  { character: 'W', variation: '' },
  { character: 'E', variation: '' },
  { character: 'R', variation: '' },
  { character: 'T', variation: '' },
  { character: 'Y', variation: '' },
  { character: 'U', variation: '' },
  { character: 'I', variation: '' },
  { character: 'O', variation: '' },
  { character: 'P', variation: '' },
  { character: 'A', variation: '' },
  { character: 'S', variation: '' },
  { character: 'D', variation: '' },
  { character: 'F', variation: '' },
  { character: 'G', variation: '' },
  { character: 'H', variation: '' },
  { character: 'J', variation: '' },
  { character: 'K', variation: '' },
  { character: 'L', variation: '' },
  { character: 'Ñ', variation: '' },
  { character: 'Z', variation: '' },
  { character: 'X', variation: '' },
  { character: 'C', variation: '' },
  { character: 'V', variation: '' },
  { character: 'B', variation: '' },
  { character: 'N', variation: '' },
  { character: 'M', variation: '' },
  { character: '.', variation: '' },
  { character: '-', variation: '' },
  { character: '@', variation: '' },
];
